<svg width="70" height="66" viewBox="0 0 70 66" fill="none" xmlns="http://www.w3.org/2000/svg">
  <g clip-path="url(#clip0_2543_29147)">
  <path fill-rule="evenodd" clip-rule="evenodd" d="M34.5 23C32.4013 23 30.7 24.7013 30.7 26.8V33.64H27.66C26.1909 33.64 25 34.8309 25 36.3V39.34C25 40.8091 26.1909 42 27.66 42H30.7C32.1691 42 33.36 40.8091 33.36 39.34V36.3H40.2C42.2987 36.3 44 34.5987 44 32.5V26.8C44 24.7013 42.2987 23 40.2 23H34.5ZM27.66 36.68C27.66 36.4701 27.8301 36.3 28.04 36.3H30.7V38.96C30.7 39.1699 30.5299 39.34 30.32 39.34H28.04C27.8301 39.34 27.66 39.1699 27.66 38.96V36.68ZM34.5 25.66C33.8704 25.66 33.36 26.1704 33.36 26.8V33.64H40.2C40.8296 33.64 41.34 33.1296 41.34 32.5V26.8C41.34 26.1704 40.8296 25.66 40.2 25.66H34.5Z" fill="white" fill-opacity="0.64"/>
  </g>
  <defs>
  <clipPath id="clip0_2543_29147">
  <rect width="19" height="19" fill="white" transform="translate(25 23)"/>
  </clipPath>
  </defs>
  </svg>
  